import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Bonjour!',
  ProductCode: 'fas44',
  Description: 'Here\'s all the online content included with your French Complete Revision & Practice. ',
  Credits: 'Contributors: Ben Ffrancon Dowds, Jackie Shaw, Coralie Stewart, Sarah Sweeney\n' +
    '\n' +
    'Proofreaders: Pat Dunn, Natalie Handley, Natalie Pomier, Véronique Robine\n' +
    '\n' +
    'AQA material is reproduced by permission of AQA. The worked solutions to questions and commentaries on questions and possible answers in this product have neither been provided by nor approved by AQA.\n' +
    '\n' +
    'Audio produced by Voice Talent Online.\n' +
    '\n' +
    'Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2024. All rights reserved.',
};
